<template>
  <div class="drawMapPage">
    <!--主页面 -->
    <div
      class="flex-row"
      v-loading="loadingCanvas"
      element-loading-text="数据加载中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      style="height: 100%"
    >
      <!-- 左侧树 -->
      <div
        class="section-mian_left flex-valign"
        :style="{ width: vsWidth + 'px' }"
        v-loading="loadingDevice"
        element-loading-text="数据加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <div class="left-type_area sbar">
          <div class="tree-container">
            <div class="title" style="position: relative">
              设备树
              <el-button
                type="text"
                :title="vsWidth > 351 ? '点击收起' : '点击展开'"
                style="
                  font-size: 20px;
                  font-size: 20px;
                  position: absolute;
                  top: -16px;
                  right: 0px;
                "
                @click="
                  () => {
                    vsWidth > 351 ? (vsWidth = 350) : (vsWidth = 400);
                    $nextTick(() => {
                      getCanvasWH();
                    });
                  }
                "
                icon="el-icon-s-operation"
              >
              </el-button>
            </div>
            <el-select
              class="form-input"
              style="width: 100%"
              v-model="checkedName"
              placeholder="请选择设备组"
            >
              <el-option style="height: auto" :value="checked">
                <!-- <div class="area-search">
                  <el-input placeholder="请输入搜索关键字"
                            prefix-icon="el-icon-search"
                            v-model="searchText"
                            clearable>
                  </el-input>
                </div> -->
                <el-scrollbar class="" style="">
                  <el-tree
                    ref="tree"
                    class="tree-content"
                    :data="treeData"
                    node-key="id"
                    :props="treeProps"
                    :default-expanded-keys="expandedKeys"
                    :expand-on-click-node="false"
                    @node-click="nodeClick"
                    :highlight-current="true"
                    :filter-node-method="filterNode"
                  >
                    <span
                      class="custom-tree-node"
                      slot-scope="{ data }"
                      style="position: relative"
                      :title="data.name"
                    >
                      <i
                        v-if="data.nodeType == 'device' && data.subDeviceMark"
                        class="icon iconfont-lunan"
                        :title="data.subDeviceMark | dic('SENU094')"
                        @contextmenu.prevent="rightClick(data)"
                        :class="['icon-lunan-SENU094' + data.subDeviceMark]"
                      ></i>
                      <i
                        v-if="data.nodeType == 'device' && !data.subDeviceMark"
                        style="color: pink"
                        title="主机"
                        @contextmenu.prevent="rightClick(data)"
                        class="icon iconfont-lunan"
                        :class="['icon-lunan-SENU087' + data.deviceMark]"
                      ></i>
                      <span
                        class="node-title"
                        :style="{
                          width:
                            (data.color || data.abscissa) && vsWidth > 301
                              ? '220px'
                              : (data.color || data.abscissa) && vsWidth < 400
                              ? '160px'
                              : !data.color && !data.abscissa && vsWidth < 400
                              ? '190px'
                              : '',
                        }"
                      >
                        {{ data.thirdCameraId ? "【" + data.thirdCameraId + "】" : ""
                        }}{{ data.name }}
                      </span>
                    </span>
                  </el-tree>
                </el-scrollbar>
              </el-option>
            </el-select>

            <div class="title">设备列表</div>
            <div class="deviceListS">
              <div class="deviceD">
                <div class="area-search" style="margin-bottom: 16px">
                  <el-input
                    placeholder="请输入搜索关键字"
                    prefix-icon="el-icon-search"
                    v-model="inputText"
                    @input="inputChange"
                    clearable
                  >
                  </el-input>
                </div>
                <div class="deviceL">
                  <div
                    v-for="item in deviceList"
                    :draggable="true"
                    @dragstart="dragStart($event, item)"
                    @contextmenu.prevent="rightClick(item)"
                    class="deviceDiv"
                    @click="deviceClick(item)"
                    :title="
                      '【' +
                      item.thirdDeviceId +
                      '】' +
                      (item.deviceName || item.parentDeviceName)
                    "
                    :key="item.deviceId"
                  >
                    <div class="buttonTip" title="" v-if="showTipId == item.deviceId">
                      <el-button
                        type="text"
                        @click.stop="showDevice(item)"
                        title="查看设备详情"
                        size="mini"
                        >查看</el-button
                      >
                      <el-button
                        type="text"
                        v-if="item.positionFlag == 1 ? true : false"
                        title="删除该设备位置"
                        slot="reference"
                        @click.stop="deleteDevice(item)"
                        size="mini"
                        >删除</el-button
                      >
                      <el-button
                        type="text"
                        title="关闭"
                        @click="
                          () => {
                            showTipId = '';
                          }
                        "
                        class="el-icon-circle-close"
                        size="mini"
                      ></el-button>
                    </div>

                    <i
                      v-if="item.subDeviceMark"
                      class="icon iconfont-lunan"
                      :title="item.subDeviceMark | dic('SENU094')"
                      :class="['icon-lunan-SENU094' + item.subDeviceMark]"
                    ></i>
                    <i
                      v-if="!item.subDeviceMark"
                      style="color: pink"
                      title="主机"
                      class="icon iconfont-lunan"
                      :class="['icon-lunan-SENU087' + item.deviceMark]"
                    ></i>
                    <span class="deviceSpan">
                      <!-- {{item.thirdDeviceId?"【"+item.thirdDeviceId+"】":'' }}{{item.parentDeviceName}} -->
                      {{ item.thirdDeviceId ? "【" + item.thirdDeviceId + "】" : ""
                      }}{{ item.deviceName || item.parentDeviceName }}
                    </span>
                    <span style="color: red" v-if="item.positionFlag == 1 ? true : false"
                      >【已定位】</span
                    >
                    <span class="showIcon" v-if="item.color && !item.abscissa"
                      >【待确认】</span
                    >
                  </div>
                  <div
                    v-if="!deviceList.length"
                    class="no-data-text"
                    style="text-align: center; padding-top: 10px"
                  >
                    <div>
                      <img src="@/common/assets/images/empty.svg" class="no-data_img" />
                    </div>
                    <div>暂无数据</div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="showMoreb && deviceList && deviceList.length < serchDeviceP.total"
              style="text-align: center"
            >
              <el-button type="primary" @click="getMoreTree" :loading="moreLoadin">{{
                moreLoadin ? "加载中" : "加载更多"
              }}</el-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 右侧表单 -->
      <div class="section-mian_right">
        <!-- 头部按钮 -->
        <div class="section-mian__toolbar flex-row">
          <img
            ref="img"
            draggable
            style="visibility: hidden"
            src="../../../../public/images/theme/newDark/device.png"
            width="20"
            height="20"
            alt=""
          />
          <img
            ref="imgCheck"
            draggable
            style="visibility: hidden"
            src="../../../../public/images/theme/newDark/deviceCheck.png"
            width="20"
            height="20"
            alt=""
          />
          <el-button
            type="primary"
            @click="cancelSite"
            :disabled="
              !canvasList.length ||
              (canvasList.length == oldCanvasData.length && !ishaveMove)
            "
            icon="el-icon-refresh"
            >全部取消</el-button
          >
          <el-button
            type="primary"
            @click="addSite"
            :disabled="
              !canvasList.length ||
              (canvasList.length == oldCanvasData.length && !ishaveMove)
            "
            icon="iconfont icon-xinzeng"
            >全部保存</el-button
          >
          <el-button
            type="primary"
            @click="back"
            style="padding: 5px 10px"
            icon="iconfont icon-iconfontfanhui"
            >返回上一页
          </el-button>
        </div>
        <div class="canvasMain">
          <div
            class="canvasMainT"
            :style="{
              width: vW + '%',
              height: vH + '%',
              marginTop: getMarginTop + 'px',
              marginLeft: getMarinLeft + 'px',
            }"
          >
            <img
              class="yhjimg"
              :src="
                getImgPath(detail.fileCode) ||
                '/images/theme/newDark/default-drawing1.jpg'
              "
            />
            <!-- src="./test.png" -->
            <canvas
              id="mycanvas"
              @mousewheel="mouseScroll"
              @DOMMouseScroll="mouseScroll"
              @mousedown="handleDomMoveStart"
              @drop="drop"
              @dragover.prevent
              @contextmenu.prevent="rightCancas"
              :width="cW"
              :height="cH"
            ></canvas>
          </div>
        </div>
        <div class="marTip">
          <div>【 放大比例 {{ vW }}% 】</div>
        </div>
      </div>
    </div>
    <!-- 新增弹窗 -->
    <el-dialog
      title="设备详情"
      v-ops:width="330"
      v-dialogDrag
      :visible.sync="deviceDetail"
      @close="deviceDetailClose"
      :close-on-click-modal="false"
    >
      <el-form :model="deviceForm" style="display: flex; flex-wrap: wrap" ref="form">
        <el-form-item
          :label="deviceForm.subDeviceMark ? '设备名称：' : '主机名称：'"
          label-width="120px"
          prop="name"
        >
          <span>{{
            deviceForm.subDeviceMark ? deviceForm.deviceName : deviceForm.deviceName
          }}</span>
        </el-form-item>
        <el-form-item
          label="设备类型："
          v-if="deviceForm.subDeviceMark"
          label-width="120px"
          prop="name"
        >
          <span>{{ deviceForm.subDeviceMark | dic("SENU094") }}</span>
        </el-form-item>
        <el-form-item
          :label="deviceForm.subDeviceMark ? '设备编号：' : '设备标识：'"
          label-width="120px"
          prop="name"
        >
          <span>{{ deviceForm.thirdDeviceId }}</span>
        </el-form-item>
        <el-form-item
          label="设备型号："
          v-if="!deviceForm.subDeviceMark"
          label-width="120px"
          prop="name"
        >
          <span>{{ deviceForm.deviceVersion }}</span>
        </el-form-item>
        <el-form-item
          label="ip地址："
          v-if="!deviceForm.subDeviceMark"
          label-width="120px"
          prop="name"
        >
          <span>{{ deviceForm.ip }}</span>
        </el-form-item>
        <el-form-item
          label="厂商："
          v-if="!deviceForm.subDeviceMark"
          label-width="120px"
          prop="name"
        >
          <span>{{ deviceForm.factoryName }}</span>
        </el-form-item>
        <el-form-item
          label="回路："
          v-if="deviceForm.subDeviceMark"
          label-width="120px"
          prop="name"
        >
          <span>{{ deviceForm.loop }}</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deviceDetailClose"> 关闭 </el-button>
      </span>
    </el-dialog>
    <div v-if="visibleTip" class="popover">
      <el-button
        type="text"
        title="关闭"
        style="position: absolute; right: 5px; top: -5px; font-size: 15px"
        @click="visibleTip = false"
        class="el-icon-circle-close"
      ></el-button>
      <div>编号：{{ popover.thirdCameraId }}</div>
      <div>名称：{{ popover.name }}</div>
      <div style="margin-top: 5px">
        <el-button
          type="primary"
          @click="showDevice(popover)"
          style="padding: 4px 5px"
          icon="el-icon-thumb"
          >查看
        </el-button>
        <el-button
          type="primary"
          @click="deleteDevice(popover)"
          style="padding: 4px 5px"
          icon="el-icon-delete"
          >删除
        </el-button>
      </div>
    </div>
    <fireImg class="fireImg" ref="fireImg" style="visibility: hidden" />
  </div>
</template>
<script>
import deviceMap from "./deviceMap";
import fireImg from "./fireImg";
import { api } from "../api";
export default {
  components: { fireImg },
  mixins: [deviceMap],
  watch: {
    vH() {
      this.$nextTick(() => {
        this.getCanvasWH();
      });
    },
    searchText(val) {
      this.$refs.tree.filter(val);
    },
  },
  computed: {
    // 视频与容器顶部距离计算
    getMarginTop() {
      return this.marginTop + this.moveYDistance;
    },
    // 视频与容器左边距离计算
    getMarinLeft() {
      return this.marginLeft + this.moveXDistance;
    },
  },
  data() {
    return {
      showMoreb: true,
      popover: {},
      visibleDelet: false,
      deviceForm: {},
      deviceDetail: false,
      showTipId: 1,
      expandedKeys: [],
      imgIsmove: true,
      loadingCanvas: true,
      detail: JSON.parse(this.$route.query.detail),
      searchText: "",
      treeProps: {
        children: "children",
        label: "name",
        isLeaf: "isLeaf",
        id: "id",
        thirdCameraId: "thirdCameraId",
      },
      treeData: [],
      cW: 0,
      cH: 0,
      canvasList: [], //已有的
      oldCanvasData: [],
      copyCanvasList: [],
      resizeStartWidth: 0,
      resizeX: 0,
      vsWidth: 350,
      resize: false,
      visibleTip: false,
      morePageNum: 0, //left tree 默认加载更多
      deviceList: [],
      deviceListBf: [],
      checkTree: {},
      loadingDevice: false,
      moreLoadin: false,
      checkedName: "",
      checked: "",
      inputText: "",
      serchDeviceP: {
        deviceMarkList: ["27", "28", "29", "35", "36", "37"], // 固定值
        systemId: 200000024,
        pageNum: 1,
        pageSize: 100,
        deviceWorkGroupCode: "",
        total: 0,
      },
    };
  },
  created() {
    this.getCanvasData();
  },
  mounted() {
    this.canvasClick();
    let _this = this;
    window.onresize = function () {
      _this.watchScreen();
    };
    this.$nextTick(() => {
      this.getCanvasWH();
    });
  },
  destroyed() {},
  methods: {
    // 输入框过滤--支持根据编号和名称查询
    inputChange(val) {
      if (val) {
        let list = this.deviceListBf.filter((el) => {
          let title = el.subDeviceMark ? el.deviceName : el.parentDeviceName;
          // return (el.deviceName && el.deviceName.indexOf(val) != -1) || (el.parentDeviceName && el.parentDeviceName.indexOf(val) != -1) || (el.thirdDeviceId && el.thirdDeviceId.indexOf(val) != -1)
          return (
            title.indexOf(val) != -1 ||
            (el.thirdDeviceId && el.thirdDeviceId.indexOf(val) != -1)
          );
        });
        this.deviceList = list;
      } else {
        this.deviceList = this.deviceListBf;
      }
      if (this.deviceList.length == this.deviceListBf.length) {
        this.showMoreb = true;
      } else {
        this.showMoreb = false;
      }
    },
    // 获取全部打点数据
    getCanvasData() {
      this.querydeviceTree();
      let params = {
        buildingCode: this.detail.buildingCode,
        deviceTypeList: ["4"],
      };
      this.$fetch(api.getCanvasList, params).then((res) => {
        if (res.success) {
          let canvasData = res.returnObj;
          canvasData.forEach((item) => {
            this.canvasList.push({
              name: item.deviceName,
              thirdCameraId: item.thirdDeviceId,
              deviceId: item.deviceId,
              width: item.width, //原始大小
              height: item.height, //原始大小
              x: item.abscissa,
              y: item.ordinate,
              subDeviceMark: item.subDeviceMark,
              deviceMark: item.deviceMark,
            });
          });
          this.oldCanvasData = [...this.canvasList];
          this.copyCanvasList = [...this.canvasList];
          this.mathCanvas();
        } else {
          this.$message({
            message: res.msgContent,
            type: "error",
          });
        }
      });
    },
    //img右击
    rightCancas(e) {
      let that = this;
      that.visibleTip = false;
      let x = e.offsetX;
      let y = e.offsetY;
      //点击选中数据
      let checkData = that.canvasList.filter((el, index) => {
        let wb = that.cW / el.width;
        let hb = that.cH / el.height;
        return Math.pow(x - el.x * wb, 2) + Math.pow(y - el.y * hb, 2) < 100;
      });
      // 寻找第一个接近的数据点
      if (checkData.length) {
        console.log(checkData);
        let val = checkData[0];
        //1. that.deviceClick(checkData[0], val)//回显
        that.visibleTip = true;
        // 2.气泡的class popover  visibleTip
        that.$nextTick(() => {
          that.popover = val;
          that.popover.id = that.popover.deviceId;
          let domPopver = document.querySelector(".popover");
          domPopver.style.position = "absolute";
          domPopver.style.top = e.pageY - 225 + "px";
          domPopver.style.left = e.pageX - 160 + "px";
        });
      }
    },
    // 点击节点获取子数据
    nodeClick(data) {
      this.checked = data.id;
      this.checkedName = data.name;
      this.loadingDevice = true;
      this.deviceList = [];
      this.deviceListBf = [];
      this.checkTree = data;
      this.serchDeviceP.pageNum = 1;
      this.serchDeviceP.deviceWorkGroupCode = data.id;
      this.serchDeviceP.total = 0;
      this.$fetch(api.queryFireDeviceList, this.serchDeviceP).then((res) => {
        setTimeout(() => {
          this.loadingDevice = false;
        }, 200);
        if (res.success) {
          this.deviceListBf = res.returnObj.list;
          this.deviceList = res.returnObj.list;
          this.serchDeviceP.total = res.returnObj.total;
        } else {
          this.$message({
            message: res.msgContent,
            type: "error",
          });
        }
      });
    },
    deviceDetailClose() {
      this.deviceForm = {};
      this.deviceDetail = false;
    },
    // 查看设备详情
    showDevice(data) {
      this.deviceDetail = true;
      this.loadingC = true;
      this.$fetch(api.getDeviceDetail, {
        deviceId: data.id || data.deviceId,
      }).then((res) => {
        setTimeout(() => {
          this.loadingC = false;
        }, 1000);
        if (res && res.success) {
          let detail = res.returnObj.deviceInfo;
          if (!detail) {
            this.$message.error("暂无设备信息");
            return;
          }
          this.deviceForm = res.returnObj.deviceInfo;
        } else {
          this.$message.error("获取设备详情失败");
        }
      });
    },
    // 右键删除定位
    deleteDevice(data) {
      // console.log(data)
      // console.log(this.canvasList)
      let axiosData = [...this.canvasList];
      let delIndex = "";
      axiosData.forEach((el, index) => {
        if (el.deviceId == data.deviceId) {
          delIndex = index;
          axiosData.splice(index, 1);
        }
      });
      this.loadingCanvas = true;
      let params = [];
      axiosData.forEach((el) => {
        params.push({
          deviceId: el.deviceId,
          buildingCode: this.detail.buildingCode,
          abscissa: el.x,
          ordinate: el.y,
          width: el.width,
          height: el.height,
        });
      });
      this.$fetch(api.updateDeviceBuilding, {
        deviceBuildingList: params,
        buildingCode: this.detail.buildingCode,
      }).then((res) => {
        setTimeout(() => {
          this.loadingCanvas = false;
        }, 1000);
        if (res && res.success) {
          this.canvasList.splice(delIndex, 1);
          this.canvasList.forEach((el) => {
            delete el.img;
          });
          this.deviceList.forEach((item) => {
            delete item.color;
            if (item.deviceId == data.deviceId) {
              item.positionFlag = "0";
            }
          });
          this.visibleDelet = false;
          this.showTipId = "";
          this.ishaveMove = false;
          this.visibleTip = false;
          this.$message.success("设备位置删除成功");
          this.clearCanvas();
          this.oldCanvasData = JSON.parse(JSON.stringify(this.canvasList));
          this.copyCanvasList = JSON.parse(JSON.stringify(this.canvasList));
          this.mathCanvas();
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 鼠标右击
    rightClick(val) {
      this.showTipId = val.deviceId;
    },
    // tree click回调
    deviceClick(val) {
      this.showTipId = "";
      let ctx = this.initCanvas();
      ctx.clearRect(0, 0, this.cH, this.cW);
      this.canvasList.forEach((el) => {
        if (el.deviceId == val.deviceId) {
          el.img = "check";
        } else {
          delete el.img;
        }
      });
      ctx.clearRect(0, 0, this.cH, this.cW);
      this.mathCanvas();
    },
    // tree 回显高亮图标
    showRedIcon(val) {
      this.deviceList.forEach((el) => {
        if (val.deviceId == el.deviceId) {
          el.color = "show";
        }
      });
    },
    // 窗口改变事件
    watchScreen() {
      this.getCanvasWH();
    },
    // 拖拽开始
    dragStart(e, data) {
      e.dataTransfer.setData("item", JSON.stringify(data));
    },
    // 拖拽结束事件
    drop(e) {
      let device = JSON.parse(e.dataTransfer.getData("item"));
      if (device.positionFlag == 1) {
        this.$message.warning("该设备已经定位,请勿拖拽");
        return;
      }
      // console.log(device)
      let offsetX = e.offsetX;
      let offsetY = e.offsetY;
      this.daDraw(offsetX, offsetY, e);
    },
    // canvas 画图
    daDraw(x, y, e) {
      let device = JSON.parse(e.dataTransfer.getData("item"));
      let isHave = this.canvasList.some((el, index) => {
        return el.deviceId == device.deviceId;
      });
      if (isHave) {
        // 已经属于待确定状态，替换old
        this.$message.warning("该设备已经处于待确定状态，请勿重复拖拽");
        return;
      }
      // console.log(device)
      this.canvasList.forEach((el) => {
        delete el.img;
      });
      this.canvasList.push({
        name: device.deviceName || device.parentDeviceName,
        thirdCameraId: device.thirdDeviceId,
        deviceId: device.deviceId,
        width: this.cW, //原始大小
        height: this.cH, //原始大小
        img: "color",
        x: x,
        y: y,
        subDeviceMark: device.subDeviceMark,
        deviceMark: device.deviceMark,
      });
      console.log(this.canvasList);
      this.clearCanvas();
      this.mathCanvas();
      this.showRedIcon(device);
    },
    // 获取canvas father W H
    getCanvasWH() {
      // 分辨率发生变化
      this.cH = document.querySelector(".canvasMainT").offsetHeight;
      this.cW = document.querySelector(".canvasMainT").offsetWidth;
      this.mathCanvas();
    },
    // 用于位置发生变化 第一次绘图 放大缩小 高亮的绘图
    mathCanvas() {
      // console.log(this.canvasList)
      this.visibleTip = false;
      if (this.canvasList.length) {
        this.canvasList.forEach((el) => {
          let wb = this.cW / el.width;
          let hb = this.cH / el.height;
          let img = "";
          // let img = this.$refs.img
          if (el.subDeviceMark) {
            // 部件
            if (!el.img) {
              let ref = "Bdefault" + el.subDeviceMark;
              img = this.$refs.fireImg.$refs[ref];
            } else {
              let ref = "Bchecked" + el.subDeviceMark;
              img = this.$refs.fireImg.$refs[ref];
            }
          } else {
            img = this.$refs.img;
            // 主机
            if (!el.img) {
              let ref = "Zdefault" + el.deviceMark;
              img = this.$refs.fireImg.$refs[ref];
            } else {
              let ref = "Zchecked" + el.deviceMark;
              img = this.$refs.fireImg.$refs[ref];
            }
          }
          let ctx = this.initCanvas();
          this.$nextTick(() => {
            if (!img) {
              if (!el.img) {
                img = this.$refs.img;
              } else {
                img = this.$refs.imgCheck;
              }
              ctx.drawImage(
                img,
                Math.round(el.x * wb - 10),
                Math.round(el.y * hb - 10),
                20,
                20
              );
            } else {
              ctx.drawImage(
                img[0],
                Math.round(el.x * wb - 10),
                Math.round(el.y * hb - 10),
                20,
                20
              );
            }
            if (el.img) {
              // img = this.$refs.imgCheck
              ctx.font = "12pt Arial";
              ctx.fillStyle = "#ff0000";
              ctx.fillText(
                "【编号:" + el.thirdCameraId + "】",
                Math.round(el.x * wb - 100) < 0 ? 0 : Math.round(el.x * wb - 100),
                Math.round(el.y * hb - 40) < 0 ? 0 : Math.round(el.y * hb - 40)
              );
              ctx.fillText(
                "【名称:" + el.name + "】",
                Math.round(el.x * wb - 100) < 0 ? 0 : Math.round(el.x * wb - 100),
                Math.round(el.y * hb - 20) < 0 ? 0 : Math.round(el.y * hb - 20)
              );
            }
          });
        });
      }
    },
    // 查看更多
    getMoreTree() {
      this.moreLoadin = true;
      this.serchDeviceP.pageNum += 1;
      this.$fetch(api.queryFireDeviceList, this.serchDeviceP).then((res) => {
        this.moreLoadin = false;
        if (res.success) {
          this.deviceList = this.deviceList.concat(res.returnObj.list);
          console.log(this.deviceListBf);
          this.deviceListBf = this.deviceListBf.concat(res.returnObj.list);
        } else {
          this.$message({
            message: res.msgContent,
            type: "error",
          });
        }
      });
    },
    //工作组树tree
    querydeviceTree() {
      this.loadingCanvas = true;
      let params = {
        deviceType: "4",
      };
      this.$fetch(api.queryDeviceWorkGroup, params).then((res) => {
        setTimeout(() => {
          this.loadingCanvas = false;
        }, 100);
        if (res && res.success) {
          const result = this.menusDataPro(res.returnObj);
          this.treeData = Object.freeze(result);
          this.nodeClick(this.treeData[0]);
          this.expandedKeys = this.expandedKeys.length
            ? this.expandedKeys
            : [this.treeData[0].id];
          // this.mathCanvas()
        } else {
          this.$message.error("获取消防设备数据失败");
        }
      });
    },
    //递归树结构
    menusDataPro(data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {};
          entity.id = item.deviceWorkGroupCode;
          entity.name = item.deviceWorkGroupName;
          entity.parentCode = item.parentCode;
          entity.deviceWorkGroupCodeList = item.deviceWorkGroupCodeList;
          entity.isLeaf = !item.hasLeaf || !item.deviceWorkGroupChildren;
          if (item.deviceWorkGroupChildren) {
            entity.children = self.menusDataPro(item.deviceWorkGroupChildren);
          }
          result.push(entity);
        });
        return result;
      }
    },
    // tree 过滤
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.name.indexOf(value) !== -1;
    },

    canvasClick() {
      let that = this;
      var canvas = document.getElementById("mycanvas");
      var ctx = canvas.getContext("2d");
      var x, y;
      let checkData = [];
      canvas.addEventListener("click", function (e) {
        // 点击事件 发起气泡
      });
      canvas.addEventListener("dblclick", function (e) {
        // 双击放大
        // that.vW += that.zoomStep;
        // that.vH += that.zoomStep;
      });
      canvas.addEventListener(
        "mousemove",
        function (e) {
          if (e.pageX || e.pageY) {
            x = e.offsetX;
            y = e.offsetY;
          } else {
            x =
              e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
            y = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
          }
          ctx.clearRect(0, 0, 150, 15);
          ctx.font = "8pt Arial";
          ctx.fillStyle = "#000000";
          ctx.fillText("【相对坐标 : X-" + x + ",Y-" + y + "】", 5, 10);
        },
        false
      );
    },
    back() {
      this.$router.push({
        path: "/cameralist/drawConfig",
      });
      // this.$router.go(-1);
    },
    //保存
    addSite() {
      this.loadingCanvas = true;
      let params = [];
      this.canvasList.forEach((el) => {
        params.push({
          deviceId: el.deviceId,
          buildingCode: this.detail.buildingCode,
          abscissa: el.x,
          ordinate: el.y,
          width: el.width,
          height: el.height,
        });
      });
      this.$fetch(api.updateDeviceBuilding, {
        deviceBuildingList: params,
        buildingCode: this.detail.buildingCode,
      }).then((res) => {
        if (res && res.success) {
          // this.expandedKeys = [this.canvasList[this.canvasList.length - 1].deviceId]
          this.ishaveMove = false;
          this.showTipId = "";
          this.visibleDelet = false;
          this.$message.success("设备位置信息保存成功");
          this.clearCanvas();
          this.canvasList.forEach((el) => {
            delete el.img;
            this.deviceList.forEach((item) => {
              delete item.color;
              if (el.deviceId == item.deviceId) {
                item.positionFlag = 1;
              }
            });
          });
          this.oldCanvasData = JSON.parse(JSON.stringify(this.canvasList));
          this.copyCanvasList = JSON.parse(JSON.stringify(this.canvasList));
          this.mathCanvas();
        } else {
          this.$message.error(res.msgContent);
        }
        setTimeout(() => {
          this.loadingCanvas = false;
        }, 500);
      });
    },
    // 取消
    cancelSite() {
      this.ishaveMove = false;
      if (this.canvasList.length > 0) {
        // 静态取消刷新机制
        let ctx = this.initCanvas();
        ctx.clearRect(0, 0, this.cH, this.cW);
        this.canvasList = JSON.parse(JSON.stringify(this.copyCanvasList));
        this.oldCanvasData = JSON.parse(JSON.stringify(this.copyCanvasList));
        this.canvasList.forEach((el) => {
          delete el.img;
        });
        this.mathCanvas();
        this.deviceList.forEach((el) => {
          delete el.color;
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.title {
  margin: 10px 0px 16px 3px;
  border-left: 5px solid #407aee;
  position: relative;
  // line-height: 16px;
  text-align: left;
  padding-left: 10px;
}

.deviceListS {
  // max-height: 65vh;
  // overflow: auto;
  .deviceD {
    padding: 0px 10px 10px;
    .deviceL {
      max-height: calc(100vh - 330px);
      overflow: auto;

      .deviceDiv {
        position: relative;
        padding: 7px 10px;
        cursor: pointer;
        display: flex;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;

        // line-height: 10px;
        // height: 20px;
        &:hover {
          @include set_theme_color(background-color, menu-tab-bg-color);

          .showIcon {
            // color: #fff !important;
          }
        }

        .deviceSpan {
          display: inline-block;
          // width: 115px;
          margin-left: 4px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
          &:hover {
            color: #407aee;
          }
        }
      }
    }
  }
}

.popover::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 20%;
  margin-left: 15%;
  border-width: 10px;
  border-style: solid;
  @include set_theme_color(border-top-color, top-menu-bg-color);
  border-color: transparent transparent transparent;
}

.popover {
  padding: 10px 15px;
  min-width: 200px;
  border-radius: 5px;
  @include set_theme_color(background-color, top-menu-bg-color);

  div {
    margin-bottom: 10px;
  }
}

.drawMapPage {
  .el-form-item {
    margin-bottom: 0;
    width: 100%;
  }

  width: 100%;
  height: 100%;

  .section-mian_left {
    width: 250px;
    padding: 0 7px;

    .left-type_area {
      flex: 1;
      overflow: hidden;

      .leftTitle {
        margin: 5px 0;

        .button {
          position: absolute;
          right: 0;
          cursor: pointer;
        }
      }
    }
  }

  .tree-container {
    .area-search {
      display: flex;
      height: 28px;
      margin-bottom: 5px;
    }

    .node-title {
      margin-bottom: -2px;
      display: inline-block;
      // width: 115px;
      margin-left: 4px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
    }

    .buttonTip {
      position: absolute;
      // left: 27px;
      top: 0px;
      height: 30px;
      z-index: 2;
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
      padding: 0 5px;
      text-align: center;
      border-radius: 4px;
      color: #fff !important;
      @include set_theme_color(background, main-theme-color);

      button {
        flex: 1;
        color: #fff !important;

        &:hover {
          opacity: 0.8;
          font-size: 13px;
        }
      }
    }

    .showIcon {
      @include set_theme_color(color, main-theme-color);

      &:hover {
        // color: #fff;
      }
    }

    /deep/.el-tree-node__content {
      &:hover {
        @include set_theme_color(background-color, main-theme-color);
      }
    }

    /deep/.el-tree {
      @include set_theme_color(background-color, top-menu-bg-color);
    }

    /deep/.el-scrollbar__wrap {
      padding: 15px 0;
      @include set_theme_color(background-color, top-menu-bg-color);
    }
  }

  .section-mian_right {
    .section-mian__toolbar {
      justify-content: flex-end;

      button {
        padding: 5px 10px;
      }
    }

    .canvasMain {
      position: relative;
      background: rgba(128, 128, 128, 0.5);
      width: 100%;
      height: 100%;
      overflow: hidden;

      .canvasMainT {
        position: absolute;

        img {
          width: 100%;
          height: 100%;
          position: absolute;
        }

        canvas {
          position: absolute;
        }
      }
    }

    .marTip {
      position: absolute;
      text-align: center;
      right: 30px;
      bottom: 20px;

      div {
        margin-bottom: 5px;
        color: black;
        // @include set_theme_color(color, main-theme-color);
      }
    }
  }
}
</style>
